import RegisterInternalUserContainer from './RegisterInternalUserContainer';
export default RegisterInternalUserContainer;

